import { z } from 'zod';

import { zodContractItemsTableSearchSchema } from '../-searchParams';

export const zodCreateContractSearchParamsSchema =
  zodContractItemsTableSearchSchema.extend({
    // Prefills the create form from the given contract; see useContractForm.ts.
    duplicateContractId: z.uuid().optional().catch(undefined),
    // Prefills the create form from the import job's OCR-extracted data.
    // The PDF is attached server-side from this id; see useContractForm.ts.
    importJobId: z.uuid().optional().catch(undefined),
  });
